/***************************************************************************
 * forceLogout does as it says: logs out the user
 **************************************************************************/
ht.forceLogout = function () {
  window.location.reload(true);
  // use the above instead of login as previous in order to handle
  // payor specific urls for logout
};
